import {Component} from "react";
import posthog from "posthog-js";


class PosthogAnalytics extends Component {
  componentDidMount() {
    const {apiKey} = this.props;

    if (process.env.NODE_ENV !== "production") return;

    posthog.init(apiKey, {api_host: 'https://app.posthog.com'});
    posthog.debug(false);
  }

  render() {
    return null;
  }
}

export default PosthogAnalytics
